import React from "react";
import { BaseLayout } from "customer/BaseLayout";
import { ManualEntry } from "customer/ManualEntry";
import { useDispatch, useSelector } from "react-redux";
import { SignedDocumentAsyncActions } from "common/reducers/signedDocument.async.actions";
import { form as formSelector } from "common/selectors/rsfForm.selectors";
import { AppDispatch } from "common/store";
import { useNavigate } from "react-router";

export const formName = "signaturesSign";

export const SignaturesSign: React.FC<{}> = () => {
  // Constants

  // Hooks
  const dispatch = useDispatch() as AppDispatch;
  const form = useSelector((state: any) => formSelector(state, { name: formName }));
  const navigate = useNavigate();

  // Selectors
  // Methods
  const onSubmit = () => {
    dispatch(SignedDocumentAsyncActions.sign(form?.get("id"), navigate));
  };

  // Lifecycle

  return (
    <BaseLayout>
      <ManualEntry
        title="Sign Document"
        label="Signature ID"
        placeholder="Enter Signature ID"
        actionLabel="Sign"
        context={formName}
        onSubmit={onSubmit}></ManualEntry>
    </BaseLayout>
  );
};
